import { compile, compileG } from "./internal/codegen";
import { DOT, DOT_G } from "./internal/templates";
import { vop } from "./internal/vop";

var $ = function $(dim) {
  return dot.add(dim, compile(dim, DOT, "a,b", undefined, null, "+", "return ", ";"));
};

export var dot = vop();
dot["default"](compileG(DOT_G, "a,b", undefined, "s", "let s=0;"));
export var dot2 = $(2);
export var dot3 = $(3);
export var dot4 = $(4);